module.exports = __webpack_public_path__ + "img/p1-pic.f550ee2a.jpg";